import { useState, useMemo, useCallback } from 'react';
import axiosInstance from '../../../api/axios';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, TextField, Grid } from '@mui/material';
import { LockOpen } from '@mui/icons-material';
import LoadingButton from '@mui/lab/LoadingButton';
import { useTheme } from '@mui/material/styles';
import { notifyError, notifySuccess } from "../../../components/common/toast/ToastFunc";
import Image from "../../../assests/images/forgot_password.jpg";

const ForgotPassword = () => {

  const theme = useTheme();

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [userID, setUserID] = useState(null);

  const buttonTheme = useMemo(() => ({
    color: 'white',
    backgroundColor: theme.mainColor,
    fontSize: "18px",
    fontWeight: 'bold',
    borderRadius: "7px",
    height: "45px",
    '&:hover': {
      backgroundColor: '#b30000',
      color: 'white',
      fontSize: "18px",
      fontWeight: 'bold',
      borderRadius: "7px",
    },
  }), [theme.mainColor]);

  const textFieldTheme = useMemo(() => ({
    '& label.Mui-focused': {
      color: theme.mainColor,
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'grey',
        borderRadius: '7px',
      },
      '&:hover fieldset': {
        borderColor: theme.mainColor,
      },
      '&.Mui-focused fieldset': {
        border: '1px solid #990000',
      },
    },
  }), [theme.mainColor]);

  const handleSubmit = useCallback(async () => {
    setLoading(true);

    try {
      const response = await axiosInstance.post('/customer/user-info/forgot-password', { user_id: userID });
      notifySuccess(response?.data?.message || "Success");
      navigate("/login");
    }
    catch (error) {
      notifyError(error.message || "Something went wrong");
    }
    finally {
      setLoading(false);
    }
  }, [navigate, userID]);

  return (
    <>
      <Grid container spacing={2} sx={{ alignItems: 'center', justifyContent: 'center', height: 'calc(100vh - 65px)' }}>
        <Grid item xs={12} md={5}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              width: "100%",
              height: "100%",
              mt: "65px",
              m: 2
            }}>
            <Typography gutterBottom sx={{ fontSize: "35px", color: "#990000", fontWeight: "bold" }}>
              Reset Your Password
            </Typography>
            <Box
              component="img"
              sx={{
                height: 500,
                width: 470,
              }}
              alt="Forgot Password Image"
              src={Image}
            />
          </Box>
        </Grid>

        <Grid item xs={12} md={7}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <Box
            component="form"
            noValidate
            autoComplete="off"
            sx={{
              maxWidth: 400,
              p: 2,
            }}
          >
            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', mb: 3 }}>
              <Typography variant="h5" sx={{ color: theme.mainColor, fontWeight: "500" }}>
                Enter your User ID
              </Typography>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="User ID"
                  variant="outlined"
                  name="userID"
                  value={userID}
                  onChange={(e) => setUserID(e.target.value)}
                  sx={{
                    ...textFieldTheme
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <LoadingButton
                  onClick={() => handleSubmit()}
                  loading={loading}
                  loadingPosition="start"
                  startIcon={<LockOpen />}
                  variant="contained"
                  sx={{ ...buttonTheme }}
                  fullWidth
                >
                  Forgot Password
                </LoadingButton>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default ForgotPassword;
